import React from 'react'
import VehicleField from 'App/components/fields/VehicleField'
import { getMessengerVehicleURL } from 'App/Root/url'

export default function SearchConversation({ history }) {
  return (
    <VehicleField
      value={null}
      onChange={vehicleId => {
        window.open(getMessengerVehicleURL(vehicleId), '_blank')
      }}
      placeholder="Buscar una conversación"
    />
  )
}
